import './App.scss';
import Dev from './components/dev';

function App() {
  return (
    <Dev />
  );
}

export default App;
